import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=2b60dc74&scoped=true&lang=html&"
import script from "./Unavailable.vue?vue&type=script&lang=js&"
export * from "./Unavailable.vue?vue&type=script&lang=js&"
import style0 from "./Unavailable.vue?vue&type=style&index=0&id=2b60dc74&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60dc74",
  null
  
)

export default component.exports